<div class="lp-root">

  <!-- Canvas partículas -->
  <canvas #lpCanvas class="lp-canvas"></canvas>

  <!-- Loading overlay -->
  <div *ngIf="(loginFacade.responseLoading$ | async)?.loading" class="lp-loading">
    <div class="lp-spin-wrap">
      <div class="lp-comet"></div>
      <p class="lp-spin-lbl">Verificando credenciales...</p>
    </div>
  </div>

  <!-- Card única, vertical -->
  <div class="lp-card">

    <!-- Banner superior: identidad -->
    <div class="lp-banner">
      <div class="lp-banner-glow"></div>

      <img src="../../../assets/images/logo/logo-unah.png" alt="UNAH" class="lp-logo" draggable="false">

      <span class="lp-chip">
        <span class="lp-chip-dot"></span>
        Postulantes
      </span>

      <h1 class="lp-title">Portal del Postulante</h1>
      <!-- <p class="lp-sub">Inicia tu proceso de admisión a los posgrados de la UNAH</p> -->
    </div>

    <!-- Cuerpo: formulario -->
    <div class="lp-body">

      <div class="lp-notice">
        <mat-icon class="lp-notice-icon">info</mat-icon>
        <p class="lp-notice-text">
          Este proceso aplica únicamente a las carreras de posgrado cuyo proceso de admisión requiere la presentación previa de documentación.
        </p>
      </div>

      <p class="lp-body-hint">
        <mat-icon class="lp-hint-icon">shield</mat-icon>
        Ingresa tus credenciales para continuar
      </p>

      <form ngNativeValidate [formGroup]="formLogin" (ngSubmit)="login()" class="lp-form">

        <mat-form-field appearance="outline" class="lp-field">
          <mat-label>Usuario</mat-label>
          <input matInput formControlName="usuario" required autocomplete="off"
            (keydown.enter)="$event.preventDefault()">
          <mat-icon matSuffix>person</mat-icon>
        </mat-form-field>

        <mat-form-field appearance="outline" class="lp-field">
          <mat-label>Contraseña</mat-label>
          <input matInput [type]="hide ? 'password' : 'text'"
            formControlName="password" required autocomplete="off">
          <button type="button" mat-icon-button matSuffix (click)="hide = !hide"
            [attr.aria-label]="'Mostrar contraseña'" [attr.aria-pressed]="hide">
            <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
        </mat-form-field>

        <div class="lp-forgot">
          <span  >¿Olvidaste tu contraseña?</span>
        </div>

        <div class="lp-actions">
          <button mat-button type="button" class="lp-btn-back" (click)="volver()">
            <mat-icon>arrow_back_ios</mat-icon> Volver
          </button>
          <button mat-raised-button type="submit" class="lp-btn-submit"
            [disabled]="(loginFacade.responseLoading$ | async)?.loading">
            <ng-container *ngIf="!(loginFacade.responseLoading$ | async)?.loading; else lpLoadTpl">
              Ingresar &nbsp;<mat-icon>east</mat-icon>
            </ng-container>
            <ng-template #lpLoadTpl>
              <mat-spinner diameter="22" strokeWidth="3"></mat-spinner>
            </ng-template>
          </button>
        </div>

      </form>

      <p class="lp-footer">UNAH &copy; {{ year }} &middot; Portal de Posgrados</p>
    </div>

  </div>

</div>
